import PesquisaSatisfacao from "../../../Components/PesquisaSatisfacao/PesquisaSatisfacao";

export default function PesquisaSatisfacaoVendas() {
    return <PesquisaSatisfacao />;
}
